import type { Country } from "@/types/deal";

export function isUKDealCountries(countries?: Country[]): boolean {
  return (
    countries?.some(
      (country) =>
        country?.name === "United Kingdom" ||
        country?.nicename === "United Kingdom" ||
        country?.id === 225,
    ) ?? false
  );
}

/** Display label for sales comps area filter inputs (no unit conversion). */
export function salesCompsAreaUnitLabel(
  countries?: Country[],
): "sq ft" | "sqm" {
  return isUKDealCountries(countries) ? "sq ft" : "sqm";
}
